import { ObtrusiveScrollCss } from "shared/components/transitions/scroll";
import styled from "styled-components";

type Props = {
  $shouldHighlight?: boolean;
  $disabled?: boolean;
  $width?: string;
  $maxDropDownHeight?: string;
};

const SelectListLITag = styled.li<Props>`
  padding: 0.5rem 1rem;
  font-size: 16px;
  transition: all 0.1s ease-in;
  background-color: ${(props: Props) =>
    props.$shouldHighlight
      ? ({ theme }) => theme.colorSelected
      : ({ theme }) => theme.colorBackgroundMain}
  color: ${(props: Props) => {
    if (props.$disabled) {
      return ({ theme }) => theme.colorTextDisabled;
    }
    return ({ theme }) => theme.colorTextMain;
  }};
  
  &:hover {
    cursor: pointer;
    background-color: ${({ theme }) => theme.colorSelected};
    color: ${(props: Props) =>
      props.$disabled
        ? ({ theme }) => theme.colorTextDisabled
        : ({ theme }) => theme.colorTextMain};
  }
`;

const SelectListULTag = styled.ul<Props>`
  list-style: none;
  position: absolute;
  right: initial;
  top: initial;
  text-align: left;
  overflow: auto;
  background-color: ${({ theme }) => theme.colorBackgroundSecondary};
  width: ${(props) => (props.$width ? props.$width : "100%")};
  max-height: ${(props) =>
    props.$maxDropDownHeight ? props.$maxDropDownHeight : "auto"};
  z-index: 100;
  margin: 0;
  padding: 0;
  border-radius: 0 0 6px 6px;
  filter: drop-shadow(0px 3px 3px rgba(0, 0, 0, 0.2));
  ${ObtrusiveScrollCss};
`;

export const SearchResultList = styled(SelectListULTag)`
  max-height: 45rem;
  width: 300px;
`;

export const SearchResultRow = styled(SelectListLITag)`
  display: grid;
  align-items: center;
  grid-template-columns: 9.7rem 6rem;
`;

export const NameColumn = styled.span`
  grid-column: 1;
`;

export const PhoneNumberColumn = styled.span`
  grid-column: 2;
  justify-self: end;
`;
